(function () {
  "use strict";
  var L = window.Lagom;
  if (!(!L || !L.q)) {
    var q = L.q,
      qa = L.qa,
      motionOff = L.motionOff,
      MOTION = L.MOTION,
      CAPTURE = L.CAPTURE,
      IMG = L.assetBase || "";
    (function () {
      var stats = q(".stats"),
        nums = qa("[data-count]");
      if (
        !stats ||
        !nums.length ||
        !("IntersectionObserver" in window) ||
        motionOff()
      )
        return;
      var strips = [];
      nums.forEach(function (el) {
        var full = el.textContent,
          sr = document.createElement("span");
        ((sr.className = "visually-hidden"), (sr.textContent = full));
        var odo = document.createElement("span");
        ((odo.className = "odo"), odo.setAttribute("aria-hidden", "true"));
        var di = 0;
        (full.split("").forEach(function (ch) {
          if (!/\d/.test(ch)) {
            odo.appendChild(document.createTextNode(ch));
            return;
          }
          var digit = document.createElement("span");
          digit.className = "odo__digit";
          var strip = document.createElement("span");
          ((strip.className = "odo__strip"),
            strip.style.setProperty("--n", ch),
            strip.style.setProperty("--d", di * 60 + "ms"));
          for (var i = 0; i <= 9; i++) {
            var n = document.createElement("span");
            ((n.textContent = String(i)), strip.appendChild(n));
          }
          (digit.appendChild(strip),
            odo.appendChild(digit),
            strips.push(strip),
            (di += 1));
        }),
          (el.textContent = ""),
          el.appendChild(sr),
          el.appendChild(odo));
      });
      var done = !1;
      function roll(instant) {
        done ||
          ((done = !0),
          instant &&
            strips.forEach(function (s) {
              s.style.transition = "none";
            }),
          stats.classList.add("is-on"));
      }
      var io;
      function watch() {
        ((io = new IntersectionObserver(
          function (entries) {
            entries.some(function (e) {
              return e.isIntersecting;
            }) && (io.disconnect(), roll(!1));
          },
          { threshold: 0.4 },
        )),
          io.observe(stats));
      }
      (watch(),
        document.addEventListener("click", function (e) {
          var a = e.target.closest && e.target.closest('a[href^="#"]');
          a && !done && roll(!0);
        }),
        window.addEventListener("pageshow", function (e) {
          e.persisted &&
            (io && io.disconnect(),
            (done = !1),
            strips.forEach(function (s) {
              s.style.transition = "";
            }),
            stats.classList.remove("is-on"),
            watch());
        }));
    })();
  }
})();

